import _ from 'underscore';

function isDate(value) {
    return (!isNaN(new Date(value).getYear()));
}

function DateClass(dateStr, fmt = 'yyyy/MM/dd hh:mm:ss') {
    if (!(dateStr instanceof DateClass)) {
        this.date = new Date(dateStr || null);
    } else {
        this.date = dateStr.date;
    }
    this.fmt = fmt;
}

_.extend(DateClass.prototype, {
    isDate: isDate,
    format(fmt) {
        fmt = fmt || this.fmt;
        let d = this.date;

        var o = {
            'M+': d.getMonth() + 1, //月份 
            'd+': d.getDate(), //日 
            'h+': d.getHours(), //小时 
            'm+': d.getMinutes(), //分 
            's+': d.getSeconds(), //秒 
            'q+': Math.floor((d.getMonth() + 3) / 3), //季度 
            'S': d.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        return fmt;
    },
    isSome(type = 'day', date = new Date) {
        let d = this.date;
        let yearOK = date.getYear() === d.getYear();
        let monthOK = date.getMonth() === d.getMonth();
        let dayOK = date.getDate() === d.getDate();
        let hourOK = date.getHours() === d.getHours();
        let secondOK = date.getSeconds() === d.getSeconds();

        switch (type) {
            case 'year':
                return yearOK;
            case 'month':
                return yearOK && monthOK;
            case 'day':
                return yearOK && monthOK && dayOK;
            case 'hour':
                return yearOK && monthOK && dayOK && hourOK;
            case 'second':
                return yearOK && monthOK && dayOK && hourOK && secondOK;
            default:
                return false;
        }
    },
    /**
        size: normal, small
    */
    shortFormat(suffix_fmt = 'hh:mm:ss', size = 'normal') {
        let fmt = this.fmt;

        if (this.isSome('day')) {
            fmt = suffix_fmt;
        } else if (this.isSome('year')) {
            fmt = 'MM/dd'
            if (size !== 'small') {
                fmt += ' ' + suffix_fmt;
            }
        }
        return this.format(fmt);
    }
});


export function dateUtil(date, fmt) {
    return new DateClass(date, fmt);
};


// WEBPACK FOOTER //
// ./src/utils/dateUtil.js